import { GlyphLoading } from "#root/components/glyphs";
import type { ReactNode } from "react";

export default function LogViewer({ log }: { log: string }): ReactNode {
  if (log == null) return <GlyphLoading/>;

  const logLines = log.split("\x03");

  return (
    <code className="log-viewer">
      {logLines.map(line => {
        const [, level, timestamp, msg] = line.match(/^\x01(.)(\d+)\x02(.*)$/) ?? [];
        if (msg) {
          return (
            <div className={`entry entry-${level}`}>
              <span className="ts">{new Date(Number.parseInt(timestamp, 10)).toLocaleString()}</span>
              <span className="msg">{msg}</span>
            </div>
          );
        } else {
          if (line === "") return;

          return (
            <div className={`entry entry-e`}>
              <span className="ts">Malformed entry</span>
              <span className="msg">{JSON.stringify(line)}</span>
            </div>
          );
        }
      })}
    </code>
  );
}
